import Resources from '../../../helpers/resources';
import { ENDPOINT_PATH_SKILL_QUESTS_MASTERY } from '../../../helpers/constants';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorActions from '../../app/errors/errors-actions';
import { moveItemToFrontArray } from '../../../helpers/utils';

/**
 * ACTION TYPES
 */
export const SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED =
    'SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED';
export const SKILL_QUESTS_MASTERY_STUDENT_REQUEST =
    'SKILL_QUESTS_MASTERY_STUDENT_REQUEST';
export const SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED =
    'SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED';
export const SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST =
    'SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST';
export const SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM =
    'SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM';
export const SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE =
    'SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE';
export const SKILL_QUESTS_MASTERY_STUDENT_RESET =
    'SKILL_QUESTS_MASTERY_STUDENT_RESET';
export const SKILL_QUESTS_MASTERY_IS_FILTERED =
    'SKILL_QUESTS_MASTERY_IS_FILTERED';

/**
 * CONSTANTS
 */
const ID_SELECTOR = 'id';

/**
 * SERVICE REQUESTS
 */
export function getStudentSkillQuestsMasteryData(
    classroomId,
    studentProfileId,
    selectedDateFilter,
    assignmentResultType
) {
    return (dispatch) => {
        dispatch({ type: SKILL_QUESTS_MASTERY_STUDENT_REQUEST });
        Resources.studentReport
            .get({
                reportType: ENDPOINT_PATH_SKILL_QUESTS_MASTERY,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId,
                userProfileId: studentProfileId
            })
            .withParams({
                ...DateParamHelper.getDateQueryParams(selectedDateFilter),
                courseId: null,
                assignmentResultType
            })
            .send()
            .then((payload) => {
                if (payload.valid) {
                    const {
                        selectedCourseId,
                        selectedPublicationCourseId
                    } = payload.data;

                    dispatch({
                        type: SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED,
                        payload: manageStudentData(payload.data, dispatch)
                    });
                    dispatch(
                        setIsFiltered(
                            selectedCourseId,
                            selectedPublicationCourseId
                        )
                    );
                } else {
                    dispatch(
                        errorActions.addError(
                            SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED
                        )
                    );
                }
            });
    };
}

export function getStudentSkillQuestsMasteryDataCourse(
    classroomId,
    studentProfileId,
    selectedDateFilter,
    courseId,
    courseVersion,
    assignmentResultType
) {
    return (dispatch) => {
        dispatch({ type: SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST });
        Resources.studentReportCourse
            .get({
                reportType: ENDPOINT_PATH_SKILL_QUESTS_MASTERY,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId,
                userProfileId: studentProfileId
            })
            .withParams({
                ...DateParamHelper.getDateQueryParams(selectedDateFilter),
                courseId,
                courseVersion,
                assignmentResultType
            })
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch({
                        type: SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED,
                        payload: payload.data
                    });
                    dispatch(setIsFiltered(courseId, courseVersion));
                } else {
                    dispatch(
                        errorActions.addError(
                            SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED
                        )
                    );
                }
            });
    };
}

/**
 * ACTIONS
 */
function setIsFiltered(courseId, courseVersion) {
    const updatedIsFiltered = courseId !== null && courseVersion !== null;

    return (dispatch) => {
        dispatch({
            type: SKILL_QUESTS_MASTERY_IS_FILTERED,
            payload: updatedIsFiltered
        });
    };
}

export function setSelectedPublication(data, selectedId) {
    return (dispatch) => {
        let selected = data.find((value) => value.id === selectedId);

        if (!selected) {
            selected = data[0];
        }

        dispatch({
            type: SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM,
            payload: {
                data,
                selected
            }
        });
    };
}

export function setSelectedCourse(data, selectedId) {
    return (dispatch) => {
        let selected = data.find((value) => value.id === selectedId);

        if (!selected) {
            selected = data[0];
        }

        dispatch({
            type: SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE,
            payload: {
                data,
                selected
            }
        });
    };
}

export function resetStudentData() {
    return (dispatch) => {
        dispatch({
            type: SKILL_QUESTS_MASTERY_STUDENT_RESET
        });
    };
}

/**
 * ACTION HELPERS
 */
function manageDropdownDefaultValues(data) {
    data.publicationCourses.map((publication) => {
        publication.value = publication.id;
        publication.label = publication.name;

        publication.courses.map((course) => {
            course.value = course.id;
            course.label = course.name;

            return course;
        });

        return publication;
    });

    return data;
}

function managePublication(data, selectedPublicationCourseId) {
    data = manageDropdownDefaultValues(data);

    data.publicationCourses = moveItemToFrontArray(
        data.publicationCourses,
        ID_SELECTOR,
        selectedPublicationCourseId
    );

    return data;
}

function manageCourse(data, selectedPublicationCourseId, selectedCourseId) {
    if (selectedPublicationCourseId && selectedCourseId) {
        data.publicationCourses = moveItemToFrontArray(
            data.publicationCourses,
            ID_SELECTOR,
            selectedPublicationCourseId
        );

        const selectedCourseIndex = data.publicationCourses.findIndex(
            (course) => course.id === selectedPublicationCourseId
        );

        data.publicationCourses[
            selectedCourseIndex
        ].courses = moveItemToFrontArray(
            data.publicationCourses[selectedCourseIndex].courses,
            ID_SELECTOR,
            selectedCourseId
        );
    }

    return data;
}

export function manageStudentData(data, dispatch) {
    const { selectedCourseId, selectedPublicationCourseId } = data;
    let updatedData = { ...data };

    updatedData = managePublication(updatedData, selectedPublicationCourseId);
    updatedData = manageCourse(
        updatedData,
        selectedPublicationCourseId,
        selectedCourseId
    );

    dispatch(
        setSelectedPublication(
            data.publicationCourses,
            selectedPublicationCourseId
        )
    );
    dispatch(
        setSelectedCourse(data.publicationCourses[0].courses, selectedCourseId)
    );

    return updatedData;
}



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/student-actions.js